<div class="flex flex-1 flex-col gap-2 h-full w-full p-3">
    <div class="flex items-center gap-3">
        <app-button variant="filled" severity="primary" icon="pi pi-plus" iconPosition="left"
            (clicked)="openGenerateContractDialog()" [label]="'Generate Contract'"
            [loading]="generateContractLoading" />
        <div class="w-[25%] min-w-[12rem]">
            <app-search-bar placeholder="Search Contract" [(ngModel)]="searchValue" (searchChange)="onSearch()"
                width="100%"></app-search-bar>
        </div>
        <div class="flex items-center gap-2 ml-auto">
            <app-select-button [options]="viewModeOptions" [(ngModel)]="viewMode"
                (selectionChange)="onViewModeChange($event)" size="small">
            </app-select-button>
            <app-popover #sortOverlay width="15rem">
                <ng-template #trigger>
                    <app-button variant="outlined" severity="contrast" icon="pi pi-sort-alt" iconPosition="left" />
                </ng-template>
                <ng-template #body>
                    <div class="flex flex-col text-sm text-gray-800">
                        <app-button variant="ghost" severity="contrast" label="Document Name"
                            [class]="'flex justify-between items-center w-full px-4 py-2 rounded-base ' + (sortField === 'name' ? 'bg-arena-orange-100 text-black' : 'hover:bg-gray-100')"
                            [icon]="sortField === 'name' ? 'pi pi-check' : ''" iconPosition="right"
                            (clicked)="setSortField('name')" />
                        <app-button variant="ghost" severity="contrast" label="Date Created"
                            [class]="'flex justify-between items-center w-full px-4 py-2 rounded-base ' + (sortField === 'createdAt' ? 'bg-arena-orange-100 text-black' : 'hover:bg-gray-100')"
                            [icon]="sortField === 'createdAt' ? 'pi pi-check' : ''" iconPosition="right"
                            (clicked)="setSortField('createdAt')" />
                        <app-button variant="ghost" severity="contrast" label="Due Date"
                            [class]="'flex justify-between items-center w-full px-4 py-2 rounded-base ' + (sortField === 'dueDate' ? 'bg-arena-orange-100 text-black' : 'hover:bg-gray-100')"
                            [icon]="sortField === 'dueDate' ? 'pi pi-check' : ''" iconPosition="right"
                            (clicked)="setSortField('dueDate')" />
                    </div>
                    <hr class="my-2" />
                    <div class="flex flex-col text-sm text-gray-800">
                        <app-button variant="ghost" severity="contrast" label="Ascending"
                            [class]="'flex justify-between items-center w-full px-4 py-2 rounded-base ' + (sortOrder === 'asc' ? 'bg-arena-orange-100 text-black' : 'hover:bg-gray-100')"
                            [icon]="sortOrder === 'asc' ? 'pi pi-arrow-down' : ''" iconPosition="right"
                            (clicked)="setSortOrder('asc')" />
                        <app-button variant="ghost" severity="contrast" label="Descending"
                            [class]="'flex justify-between items-center w-full px-4 py-2 rounded-base ' + (sortOrder === 'desc' ? 'bg-arena-orange-100 text-black' : 'hover:bg-gray-100')"
                            [icon]="sortOrder === 'desc' ? 'pi pi-arrow-up' : ''" iconPosition="right"
                            (clicked)="setSortOrder('desc')" />
                    </div>
                </ng-template>
            </app-popover>
            <app-button variant="outlined" severity="contrast" icon="pi pi-filter" iconPosition="left"
                (clicked)="toggleFilterPanel()" [label]="'Filters'" />
        </div>
    </div>

    <div class="flex-1 min-h-0 flex flex-col">
        <ng-container *ngIf="contractsLoaded && !tableConfig.loading && contracts.length === 0; else dataBlock">
            <div class="w-full flex justify-center h-full flex-1 items-center">
                <div class="flex flex-col w-[25%] min-w-[16rem] text-center">
                    <img class="z-10 align-middle mx-auto" [src]="'images/bob_agent/top-left-point-bob.svg' | assetUrl"
                        alt="" height="200" width="200" draggable="false">
                    <span class="text-gray-600 mt-4">Click “+ Generate Contract”</span>
                    <!-- <span class="text-gray-600">There are currently no documents</span> -->
                </div>
            </div>
        </ng-container>
        <ng-template #dataBlock>
            <app-grid-list-view [items]="contracts" [viewMode]="viewMode" [gridItemTemplate]="gridItemTemplate"
                [dataKey]="'_id'" [scrollable]="true" [rows]="rows" [rowsPerPageOptions]="[20, 30, 40]"
                [useDataTable]="viewMode === 'list'" [tableColumns]="tableColumns" [tableConfig]="tableConfig"
                [customTemplates]="templatesMap" [totalRecords]="totalRecords" [first]="first" [showPaginator]="true"
                (pageChange)="onPageChange($event)" [maxHeight]="'calc(100vh - 12rem)'"
                [parentClass]="'flex-1 flex flex-col min-h-0 h-full'" [itemsLoading]="tableConfig.loading || false">
            </app-grid-list-view>
            <ng-template #gridItemTemplate let-document>
                <app-document-card [document]="document" [currentUser]="currentUser"
                    [contractMenuItems]="getMenuItems(document)" [showProjectName]="true"
                    [showGenerationLoader]="document.generationStatus === CONTRACT_GENERATION_STATUS.IN_PROGRESS"
                    (documentClick)="openContract(document._id, document.generationStatus, document.source)"
                    (menuClick)="handleMenuClick($any($event).event, $any($event).documentId, $any($event).documentName, $any($event).item)"
                    (menuToggle)="handleClick($any($event).event, $any($event).menu)"
                    (popoverToggle)="handlePopoverToggle($event)" (popoverToggle)="handlePopoverToggle($event)"
                    [showDocumentType]="false">
                </app-document-card>
            </ng-template>
        </ng-template>
    </div>

    <ng-template #documentNameTemplateRef let-document="$implicit">
        <div class="flex items-center gap-2 cursor-pointer hover:bg-gray-50 -mx-2 px-2 py-1 rounded transition-all"
            (click)="document?._id && openContract(document._id, document.generationStatus, document.source)">
            <div class="flex-1">
                <div class="font-medium text-gray-900 hover:text-arena-orange transition-colors truncate max-w-[14rem]">
                    {{ document?.name ?? 'Untitled Document' }}
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template #documentTypeTemplateRef let-document="$implicit">
        <div class="text-sm text-gray-700 truncate max-w-[10rem]">
            {{ getDocumentTypeName(document.linkedDocType) || ('No type' | titlecase) }}
        </div>
    </ng-template>
    <ng-template #projectTemplateRef let-document="$implicit">
        <div class="text-sm text-gray-700 truncate max-w-[10rem]">
            {{ document?.project?.name ?? 'No project' }}
        </div>
    </ng-template>
    <ng-template #createdByTemplateRef let-document="$implicit">
        <div class="text-sm text-gray-700 truncate max-w-[10rem]">
            {{ getCreatedByName(document.createdBy) }}
        </div>
    </ng-template>

    <ng-template #dueDateTemplateRef let-document="$implicit">
        <div class="text-sm"
            [ngClass]="{'text-danger font-semibold': document.dueDateExceeding, 'font-light': !document.dueDateExceeding}">
            {{ document.dueDate | date: 'dd MMM yyyy' }}
        </div>
    </ng-template>
    <ng-template #dateCreatedTemplateRef let-document="$implicit">
        <div class="text-sm font-light">{{ document.createdAt | date: 'dd MMM yyyy' }}</div>
    </ng-template>
    <ng-template #actionsTemplateRef let-document="$implicit">
        <div class="flex items-center justify-center" (click)="$event.stopPropagation()">
            @if(document?.generationStatus === CONTRACT_GENERATION_STATUS.IN_PROGRESS) {
            <div class="flex items-center justify-center w-8 h-8">
                <img src="icons/template-library/generation_in_progress.svg" alt="Generating"
                    class="w-4 h-4 animate-spin">
            </div>
            }
            @else {
            <app-popover #rowMenu width="12rem">
                <ng-template #trigger>
                    <app-button icon="pi pi-ellipsis-v" iconPosition="left"
                        (clicked)="openDocumentMenu(document._id, document.name)" />
                </ng-template>
                <ng-template #body>
                    <div class="flex flex-col text-sm">
                        @if (getMenuItems(document)[0].items?.length) {
                        @for (item of getMenuItems(document)[0].items; track item.label) {
                        <div (click)="handleMenuItemClick(item.label!, rowMenu)"
                            class="flex items-center gap-2 px-4 py-2 hover:bg-gray-50 cursor-pointer transition-colors"
                            [ngStyle]="item.style">
                            <i [class]="item.icon" class="text-sm"></i>
                            <span>{{ item.label }}</span>
                        </div>
                        }
                        }
                    </div>
                </ng-template>
            </app-popover>
            }
        </div>
    </ng-template>
</div>

<app-dialog [(visible)]="rename.open" (closed)="resetRename()" class="max-w-[30rem]">
    <ng-template #bodyTemplate>
        <div class="flex flex-col align-items-center py-4 px-6">
            <span class="font-bold text-xl block mb-2 mt-4">Rename Document</span>
            <p class="mb-0">Enter the new name for the Document:</p>
            <div class="flex align-items-center gap-3 my-3">
                <input class="input w-full border outline-none rounded-base p-2 text-sm"
                    (click)="$event.stopPropagation()" [(ngModel)]="rename.newName" autocomplete="off" />
            </div>
            <div class="flex justify-end items-end gap-2 mt-4">
                <app-button label="Cancel" (clicked)="rename.open = false" variant="outlined" severity="contrast" />
                <app-button label="Save" icon="pi pi-save" (clicked)="renameContract($event)" [enableThrottle]="true"
                    variant="filled" severity="primary" />
            </div>
        </div>
    </ng-template>
</app-dialog>

<app-dialog [(visible)]="dueDate.open" (closed)="resetDueDate()" class="max-w-[30rem]">
    <ng-template #bodyTemplate>
        <div class="flex flex-col align-items-center py-4 px-6">
            <span class="font-bold text-xl block mb-2 mt-4">Due Date</span>
            <p class="mb-0">Select the Due Date for this document:</p>
            <div class="flex align-items-center gap-3 my-3">
                <app-datepicker [(value)]="dueDate.selectedDate" [config]="{
                    showIcon: true,
                    placeholder: 'Select Due Date',
                    dateFormat: 'dd M yy',
                    appendTo: 'body',
                    minDate: currentDate
                }" />
            </div>
            <div class="flex justify-end items-end gap-2 mt-4">
                <app-button label="Cancel" (clicked)="dueDate.open = false" variant="outlined" severity="contrast" />
                <app-button label="Save" icon="pi pi-save" (clicked)="saveDueDate($event)" [enableThrottle]="true"
                    variant="filled" severity="primary" />
            </div>
        </div>
    </ng-template>
</app-dialog>

@if (deleteDialogVisible) {
<app-delete-confirmation [(visible)]="deleteDialogVisible" headerText="Are you sure?"
    bodyText="This action will delete the document permanently" confirmButtonText="Delete" [requireConfirmation]="true"
    (onConfirm)="confirmDeleteContract()">
</app-delete-confirmation>
}

<p-drawer [(visible)]="filterPanelVisible" position="right" class="w-[22rem]">
    <ng-template pTemplate="headless">
        <div class="flex flex-col h-full">
            <div class="flex items-center justify-between border-b p-4">
                <h2 class="text-lg font-semibold">Filter</h2>
                <app-button icon="pi pi-times" (clicked)="toggleFilterPanel()" variant="filled" severity="contrast" />
            </div>
            <div class="flex-1 overflow-y-auto space-y-5 text-sm text-gray-800 p-4">
                <div>
                    <label class="block font-medium mb-1">My Documents</label>
                    <app-select [(value)]="selectedCode" [options]="contractOptions" [config]="contractSelectConfig"
                        (onChange)="handleChange($event)" />
                </div>
                <div>
                    <label class="block font-medium mb-1">People</label>
                    <app-select [(value)]="selectedPeople" [options]="peopleOptions" [config]="peopleSelectConfig"
                        (onChange)="handlePeopleChange($event)" />
                </div>
                <div>
                    <label class="block font-medium mb-1">Project</label>
                    <app-select [(value)]="selectedProjectId" [options]="projectOptions" [config]="projectSelectConfig"
                        (onChange)="handleProjectChange($event)" />
                </div>
                <div>
                    <label class="block font-medium mb-1">Status Type</label>
                    <app-select [(value)]="selectedStatus" [options]="statusOptions" [config]="statusSelectConfig"
                        (onChange)="handleStatusChange($event)" />
                </div>
                <div>
                    <label class="block font-medium mb-1">Due Date</label>
                    <app-datepicker [(value)]="filterDueDateRange" [config]="{
                        selectionMode: 'range',
                        showIcon: true,
                        appendTo: 'body',
                        dateFormat: 'dd M yy',
                        placeholder: 'Select Due Date'
                    }" class="w-full" />
                </div>
            </div>
            <div class="flex justify-between items-center px-6 py-4 border-t">
                <app-button label="Clear all and apply" (clicked)="clearAllFilters()" [enableThrottle]="true"
                    variant="outlined" severity="contrast" />
                <app-button label="Apply Filter" (clicked)="applyFilters()" [enableThrottle]="true" variant="filled"
                    severity="primary" />
            </div>
        </div>
    </ng-template>
</p-drawer>

<app-dialog [(visible)]="generateContractGeneratingDialogVisible" (closed)="onCloseGenerateContractGeneratingDialog()"
    class="max-w-[32rem] template-generation-dialog">
    <ng-template #headerTemplate>
        <div class="flex items-center justify-between w-full">
            <h2 class="text-lg font-semibold text-gray-900">Generate document</h2>
        </div>
    </ng-template>
    <ng-template #bodyTemplate>
        <div class="flex flex-col items-center gap-6 py-4">
            <app-credits-overview class="w-full" [hidden]="!generationExhaustionState" variant="exhaustioncard"
                feature="GENERATE_WITH_AI" [featureId]="generatingContractId"
                (exhaustionState)="generationExhaustionState = $event" (resume)="onGenerationResume()" />
            @if (!generationExhaustionState) {
            <div class="relative flex items-center justify-center w-full">
                @if (templateGenerationAnimationData) {
                <div class="relative">
                    <app-lottie-animation [animationData]="templateGenerationAnimationData" [loop]="true"
                        [autoplay]="true" width="300px" height="300px" containerClass="template-generation-lottie">
                    </app-lottie-animation>
                </div>
                }
            </div>
            <div class="flex flex-col gap-2 text-center">
                <p class="text-sm text-gray-900 leading-relaxed">
                    We're generating your document and extracting structure. You'll be notified once it's ready.
                </p>
            </div>
            }
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex justify-end">
            <app-button variant="outlined" severity="contrast" label="Hide" (clicked)="onCloseGenerateContractDialog()">
            </app-button>
        </div>
    </ng-template>
</app-dialog>

<app-generate-document [(visible)]="generateContractDialogVisible" [docTypeId]="selectedDocTypeId ?? ''"
    (onGenerate)="onGenerateContract($event)"></app-generate-document>
